import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Product from "@/pages/Product";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Checkout from "@/pages/Checkout";
import CheckoutResult from "@/pages/CheckoutResult";
import Account from "@/pages/Account";
import About from "@/pages/About";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideChrome = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!hideChrome && <Header />}
      <main className={!hideChrome ? "min-h-screen" : ""}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/loja" element={<Catalog />} />
          <Route path="/categoria/:slug" element={<Catalog />} />
          <Route path="/produto/:slug" element={<Product />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/result" element={<CheckoutResult />} />
          <Route path="/conta" element={<Account />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/admin/*" element={<Admin />} />
        </Routes>
      </main>
      <CartDrawer />
      {!hideChrome && <Footer />}
      {!hideChrome && <StickyMobileCTA />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
